import axios from 'axios'
import React from 'react'
import { baseUrl } from '../../config/clientsConfig';

const SittingService = {
    createSitting: async (body)=>{
        return axios.post(`${baseUrl}/property-sittings`, body);
    },
    updateSitting: async ( body)=>{
        return axios.put(`${baseUrl}/property-sittings/update`, body);
    },
    getSittings: async (body)=>{
        return axios.post(`${baseUrl}/property-sittings/list`, body);
    },
    getSittingById: async (propertyId ,sittingId)=>{
        return axios.get(`${baseUrl}/property-sittings/${propertyId}/${sittingId}`);
    },


    getSittingOverall : async (body)=>{
        return axios.post(`${baseUrl}/property-sittings/overall`,body);
    },
    getSittingOverallCount : async (body)=>{
        return axios.post(`${baseUrl}/property-sittings/count`,body);
    },

    moveToNextStage : async (body)=>{
        return axios.put(`${baseUrl}/rough-properties/move-stage`,body);
    },
    sittingUpdateStatus : async (body)=>{
        return axios.post(`${baseUrl}/property-sittings/status-update`,body);
    },
    getSittingHistory : async (propertyId, params = {})=>{
        return axios.get(`${baseUrl}/property-sittings/${propertyId}/history`, { params });
    }
}

export default SittingService
